/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Alert from './Alert';
import L from './Lang';
import BaseCom from './BaseCom';
import FormInput from './FormInput';
import LoadingAlert from './LoadingAlert';
import { withParamsAndNavigate } from './WithParamsAndNavigate';
import { qreq } from '../shared/qrequest';
import Icon from './Icon';
import './SetPassword.css';
import Auth from '../shared/Auth';

class SetPassword extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            creds: {
                firstName: '',
                code: props.params.code,
                password: '',
                confirmPassword: ''
            },
            loaded: false,
            submitting: false
        };

        this.setUser = props.setUser;
        this.onSubmit = this.onSubmit.bind(this);
    }

    componentDidMount() {
        qreq.post('/api/auth/reset-password/check', this.state.creds, j => {
            if (j.errorCode !== 0) {
                this.alert(j.errorMessage);
                this.props.navigate(Auth.exitPath);
            }
            else if (j.item) {
                this.setState({
                    firstName: j.item.firstName,
                    loaded: true
                });
            }
        }, () => {
            this.alert('An unknown error has occurred.');
            this.props.navigate(Auth.exitPath);
        });
    }

    onSubmit(e) {
        e.preventDefault();

        if (!this.state.creds.password || this.state.creds.password.length < 6) {
            this.alert('Passwords must be at least 6 characters long.');
            return;
        }

        if (this.state.creds.password !== this.state.creds.confirmPassword) {
            this.alert('Passwords do not match.');
            return;
        }

        this.setState({ submitting: true });

        qreq.post('/api/auth/reset-password', this.state.creds, j => {
            if (j.errorCode !== 0)
                this.alert(j.errorMessage);
            else if (j.item) {
                this.setUser?.(j.item);
                this.props.navigate(Auth.followPath);
            }

            this.setState({ submitting: false });
        }, () => {
            this.alert('An unknown error has occurred.');
            this.setState({ submitting: false });
        });
    }

    render() {
        return (
            <section className="set-password-page">
                <div className="set-password-bg" />

                <div className="container-fluid set-password-container">
                    <div className="row justify-content-center align-items-center min-vh-100">
                        <div className="col-12 col-sm-10 col-md-7 col-lg-5 col-xl-4">
                            <div className="set-password-brand">
                                <img src="/img/logo-d.png" alt="" className="img-fluid" />
                            </div>

                            <div className="set-password-card">
                                {!this.state.loaded ? <>
                                    <div className="set-password-icon">
                                        <Icon icon="faShield" />
                                    </div>

                                    <h1 className="set-password-title"><L>Verifying Link</L></h1>
                                    <p className="set-password-subtitle">
                                        <L>Please wait while we verify your password reset link.</L>
                                    </p>

                                    <LoadingAlert />
                                </> : <>
                                    <div className="set-password-icon">
                                        <Icon icon="faLock" />
                                    </div>

                                    <h1 className="set-password-title"><L>Set Password</L></h1>
                                    <p className="set-password-subtitle">
                                        <L>Hello</L> <strong>{this.state.firstName}</strong>. <L>Please create a new secure password below.</L>
                                    </p>

                                    <form onSubmit={this.onSubmit} className="set-password-form">
                                        <FormInput
                                            model={this.state.creds}
                                            name="password"
                                            label="New Password"
                                            type="password"
                                            required={true}
                                            labelAsPlaceholder={true}
                                            autoComplete="new-password"
                                        />

                                        <FormInput
                                            model={this.state.creds}
                                            name="confirmPassword"
                                            label="Confirm New Password"
                                            type="password"
                                            required={true}
                                            labelAsPlaceholder={true}
                                            autoComplete="new-password"
                                        />

                                        <div className="set-password-rules">
                                            <Icon icon="faInfoCircle" />
                                            <span><L>Password must be at least 6 characters long.</L></span>
                                        </div>

                                        {this.state.error ? (
                                            <Alert message={this.state.error} type="danger" className="mt-3" />
                                        ) : ''}

                                        <div className="d-grid gap-2 mt-4">
                                            <button type="submit" className="btn btn-primary btn-lg set-password-submit" disabled={this.state.submitting}>
                                                {this.state.submitting ? <>
                                                    <Icon icon="faRefresh" className="spinner" /> <L>Saving...</L>
                                                </> : <>
                                                    <Icon icon="faCheck" /> <L>Set Password</L>
                                                </>}
                                            </button>

                                            <button type="button" className="btn btn-light btn-lg set-password-cancel" disabled={this.state.submitting} onClick={() => this.props.navigate('/login')}>
                                                <L>Cancel and Go to Login</L>
                                            </button>
                                        </div>
                                    </form>
                                </>}
                            </div>

                            <p className="set-password-note">
                                <L>For your protection, password reset links can only be used once.</L>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default withParamsAndNavigate(SetPassword);
